"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @since 0.1.0
 */
exports.eq = {
    reflexivity: function (E) { return function (a) {
        return E.equals(a, a);
    }; },
    simmetry: function (E) { return function (a, b) {
        return E.equals(a, b) === E.equals(b, a);
    }; },
    transitivity: function (E) { return function (a, b, c) {
        return (E.equals(a, b) && E.equals(b, c)) === (E.equals(a, b) && E.equals(a, c));
    }; }
};
/**
 * @since 0.1.0
 */
exports.ord = {
    totality: function (O) { return function (a, b) {
        return O.compare(a, b) <= 0 || O.compare(b, a) <= 0;
    }; },
    reflexivity: function (O) { return function (a) {
        return O.compare(a, a) <= 0;
    }; },
    antisimmetry: function (O) { return function (a, b) {
        return (O.compare(a, b) <= 0 && O.compare(b, a) <= 0) === O.equals(a, b);
    }; },
    transitivity: function (O) { return function (a, b, c) {
        return !(O.compare(a, b) <= 0 && O.compare(b, c) <= 0) || O.compare(a, c) <= 0;
    }; }
};
/**
 * @since 0.1.0
 */
exports.semigroup = {
    associativity: function (S, E) { return function (a, b, c) {
        return E.equals(S.concat(S.concat(a, b), c), S.concat(a, S.concat(b, c)));
    }; }
};
/**
 * @since 0.1.0
 */
exports.monoid = {
    rightIdentity: function (M, E) { return function (a) {
        return E.equals(M.concat(a, M.empty), a);
    }; },
    leftIdentity: function (M, E) { return function (a) {
        return E.equals(M.concat(M.empty, a), a);
    }; }
};
var allEquals = function (E) { return function (a) {
    var as = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        as[_i - 1] = arguments[_i];
    }
    return as.every(function (item) { return E.equals(item, a); });
}; };
/**
 * @since 0.1.0
 */
exports.semiring = {
    addAssociativity: function (S, E) { return function (a, b, c) {
        return E.equals(S.add(S.add(a, b), c), S.add(a, S.add(b, c)));
    }; },
    addIdentity: function (S, E) { return function (a) {
        return allEquals(E)(a, S.add(a, S.zero), S.add(S.zero, a));
    }; },
    commutativity: function (S, E) { return function (a, b) {
        return E.equals(S.add(a, b), S.add(b, a));
    }; },
    mulAssociativity: function (S, E) { return function (a, b, c) {
        return E.equals(S.mul(S.mul(a, b), c), S.mul(a, S.mul(b, c)));
    }; },
    mulIdentity: function (S, E) { return function (a) {
        return allEquals(E)(a, S.mul(a, S.one), S.mul(S.one, a));
    }; },
    leftDistributivity: function (S, E) { return function (a, b, c) {
        return E.equals(S.mul(a, S.add(b, c)), S.add(S.mul(a, b), S.mul(a, c)));
    }; },
    rightDistributivity: function (S, E) { return function (a, b, c) {
        return E.equals(S.mul(S.add(a, b), c), S.add(S.mul(a, c), S.mul(b, c)));
    }; },
    annihilation: function (S, E) { return function (a) {
        return allEquals(E)(S.zero, S.mul(a, S.zero), S.mul(S.zero, a));
    }; }
};
/**
 * @since 0.1.0
 */
exports.ring = {
    additiveInverse: function (R, E) { return function (a) {
        return allEquals(E)(R.sub(a, a), R.add(R.sub(R.zero, a), a), R.zero);
    }; }
};
/**
 * @since 0.1.0
 */
exports.field = {
    commutativity: function (F, S) { return function (a, b) {
        return S.equals(F.mul(a, b), F.mul(b, a));
    }; },
    integralDomain: function (F, S) { return function (a, b) {
        return S.equals(a, F.zero) || S.equals(b, F.zero) || !S.equals(F.mul(a, b), F.zero);
    }; },
    nonNegativity: function (F, S) { return function (a) {
        return S.equals(a, F.zero) || F.degree(a) >= 0;
    }; },
    quotient: function (F, S) { return function (a, b) {
        var q = F.div(a, b);
        var r = F.mod(a, b);
        return S.equals(b, F.zero) || S.equals(a, F.add(F.mul(q, b), r));
    }; },
    reminder: function (F, S) { return function (a, b) {
        var r = F.mod(a, b);
        return S.equals(b, F.zero) || S.equals(r, F.zero) || F.degree(a) <= F.degree(b);
    }; },
    submultiplicative: function (F, S) { return function (a, b) {
        return S.equals(a, F.zero) || S.equals(b, F.zero) || F.degree(a) <= F.degree(F.mul(a, b));
    }; },
    inverse: function (F, S) { return function (a) {
        var i = F.div(F.one, a);
        return S.equals(a, F.zero) || allEquals(S)(F.one, F.mul(i, a), F.mul(a, i));
    }; }
};
/**
 * @since 0.1.0
 */
exports.functor = {
    identity: function (F, S) { return function (fa) {
        return S.equals(F.map(fa, function (a) { return a; }), fa);
    }; },
    composition: function (F, S, ab, bc) { return function (fa) {
        return S.equals(F.map(fa, function (a) { return bc(ab(a)); }), F.map(F.map(fa, ab), bc));
    }; }
};
/**
 * @since 0.1.0
 */
exports.apply = {
    associativeComposition: function (F, S) { return function (fa, fab, fbc) {
        return S.equals(F.ap(F.ap(F.map(fbc, function (bc) { return function (ab) { return function (a) { return bc(ab(a)); }; }; }), fab), fa), F.ap(fbc, F.ap(fab, fa)));
    }; }
};
/**
 * @since 0.1.0
 */
exports.applicative = {
    identity: function (F, S) { return function (fa) {
        return S.equals(F.ap(F.of(function (a) { return a; }), fa), fa);
    }; },
    homomorphism: function (F, S, ab) { return function (a) {
        return S.equals(F.ap(F.of(ab), F.of(a)), F.of(ab(a)));
    }; },
    interchange: function (F, S) { return function (a, fab) {
        return S.equals(F.ap(fab, F.of(a)), F.ap(F.of(function (ab) { return ab(a); }), fab));
    }; },
    derivedMap: function (F, S, ab) { return function (fa) {
        return S.equals(F.map(fa, ab), F.ap(F.of(ab), fa));
    }; }
};
/**
 * @since 0.1.0
 */
exports.chain = {
    associativity: function (F, S, afb, bfc) { return function (fa) {
        return S.equals(F.chain(F.chain(fa, afb), bfc), F.chain(fa, function (a) { return F.chain(afb(a), bfc); }));
    }; },
    derivedAp: function (F, S, fab) { return function (fa) {
        return S.equals(F.ap(fab, fa), F.chain(fab, function (f) { return F.map(fa, f); }));
    }; }
};
/**
 * @since 0.1.0
 */
exports.monad = {
    leftIdentity: function (M, S, afb) { return function (a) {
        return S.equals(M.chain(M.of(a), afb), afb(a));
    }; },
    rightIdentity: function (M, S) { return function (fa) {
        return S.equals(M.chain(fa, M.of), fa);
    }; },
    derivedMap: function (M, S, ab) { return function (fa) {
        return S.equals(M.map(fa, ab), M.chain(fa, function (a) { return M.of(ab(a)); }));
    }; }
};
